import { Skeleton } from '@heidi/design-system/skeleton';

// Fixed widths so the shimmer doesn't reshape between renders — random per
// mount would jitter if the popover reopens while data is still loading.
const TITLE_WIDTHS = ['70%', '55%', '82%', '48%', '65%'] as const;

/**
 * Placeholder shown inside the notifications popover while the notifications
 * or preferences queries are pending. Mirrors the vertical rhythm of
 * `NotificationCard` (title line + timestamp line, `pb-2 pt-3 px-3.5`) so
 * the layout doesn't jump when real rows swap in.
 */
export const NotificationsSkeleton = () => (
  <div className="flex w-full flex-col" aria-hidden="true">
    {TITLE_WIDTHS.map((width, i) => (
      <div key={i} className="flex flex-col gap-1.5 px-3.5 pb-2 pt-3">
        <Skeleton className="h-3.5 rounded-sm" style={{ width }} />
        <Skeleton className="h-2.5 w-16 rounded-sm" />
      </div>
    ))}
  </div>
);
